import PropTypes from "prop-types";
import { useState } from "react";
import {
  ShareAltOutlined,
  EnvironmentOutlined,
  DownOutlined,
} from "@/config/antd";
import Avatar from "@/components/common/Avatar";
import WebIcon from "@/components/common/Web_Icons";
import LocationModal from "@/pages/polls_&_survey/components/Location_Modal";
import Button from "@/components/common/Button";

const PollInfo = ({
  date,
  time,
  title,
  description,
  totalRespondents,
  respondents,
  duration,
  location,
}) => {
  const [isLocationModalVisible, setIsLocationModalVisible] = useState(false);

  const handleLocationClick = () => {
    setIsLocationModalVisible(true);
  };

  return (
    <div className="text-left">
      <div className="flex justify-between">
        <div className="flex items-center justify-center gap-1 ">
          <h3 className="font-bold tracking-wide text-primary text-small">
            {date}
          </h3>

          <div className="bg-grey w-[.5px] h-[10px] mt-[3px]"></div>

          <h3 className="font-bold tracking-wide text-primary text-small">
            {time} <span className="ml-[.5]">PROMPT</span>
          </h3>
        </div>

        <div className="flex items-center gap-4 p-2 bg-grey">
          <span className="font-normal uppercase text-lighterGrey text-small">
            SHARE
          </span>
          <ShareAltOutlined style={{ fontSize: "15px" }} />
          <WebIcon icon="Message" size="small" />
        </div>
      </div>

      <h1 className="mb-4 heading-regular">{title}</h1>

      <p className="mb-8 font-normal leading-relaxed text-bold">
        {description}
      </p>

      {/* Respondents Section */}
      <div>
        {/* Top Divider */}
        <div className="my-6 border-t border-gray-200" />

        <div className="flex flex-col gap-4">
          <div className="flex justify-between">
            <div className="flex flex-col gap-3">
              {/* Respondents Count */}
              <h2 className="heading-regular text-darkGrey">
                {totalRespondents} Respondents
              </h2>

              {/* Avatars and Dropdown Row */}
              <div className="flex -space-x-2">
                {respondents.map((respondent, index) => (
                  <Avatar
                    key={respondent.email ?? index}
                    src={respondent.profileImage || respondent.avatar}
                    size={40}
                    className="border-2 border-white rounded-full"
                    style={{
                      zIndex: respondents.length - index,
                      backgroundColor: "#f5f5f5",
                    }}
                  />
                ))}
              </div>
              {/* Duration */}
              <div className="font-bold text-small text-darkGrey">
                Duration: {duration}
              </div>
              {/* Location */}
              <div className="flex gap-2 text-small lg:hidden">
                <span>{location}</span>
                <div className="flex items-center gap-1 font-bold">
                  <EnvironmentOutlined />
                  <button className="text-black">Open Location Map</button>
                </div>
              </div>
            </div>

            <div className="flex flex-col items-end gap-2">
              <Button
                text="Location"
                icon={<DownOutlined />}
                iconPosition="right"
                className="border border-primary whitespace-nowrap text-small font-normal rounded-[5px] w-[110px] h-[38px] flex items-center justify-center gap-2"
                customBgColor="white"
                customTextColor="black"
                onClick={handleLocationClick}
              />
              <div className="flex-col items-end hidden gap-2 text-small lg:flex">
                <span>{location}</span>
                <div className="flex items-center gap-1 font-bold">
                  <EnvironmentOutlined />
                  <button className="text-black">Open Location Map</button>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Divider */}
        <div className="my-6 border-t border-gray-200" />
      </div>
      <LocationModal
        isVisible={isLocationModalVisible}
        onClose={() => setIsLocationModalVisible(false)}
        location={location}
      />
    </div>
  );
};

PollInfo.propTypes = {
  date: PropTypes.string,
  time: PropTypes.string,
  title: PropTypes.string,
  description: PropTypes.string,
  totalRespondents: PropTypes.number,
  duration: PropTypes.string,
  location: PropTypes.string,
  respondents: PropTypes.arrayOf(
    PropTypes.shape({
      email: PropTypes.string,
      fullname: PropTypes.string,
      profileImage: PropTypes.string,
    })
  ),
};

export default PollInfo;
